import '../styles/main.scss'

import ProductGrid from './product-grid'
import { preloadImages } from './utils'

window.addEventListener('load', async () => {
  new ProductGrid()

  // load all the images
  const images = [...document.querySelectorAll('img')]
  await preloadImages(images).then(() => {
    document.body.classList.remove('loading')
  })

  /* preview thumbnails have no pointer, so pieces take turns opening */
  if (new URLSearchParams(location.search).has('autoplay')) {
    const products = [...document.querySelectorAll('.product')]
    let i = 0
    setInterval(() => {
      products.forEach((p) => p.dispatchEvent(new Event('mouseleave')))
      products[i].dispatchEvent(new Event('mouseenter'))
      i = (i + 1) % products.length
    }, 2400)
  }
})
